/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ShareTargetForReservation extends models.ShareTarget {
    constructor() {
        super();
        this.setDiscriminator("ShareTargetForReservation");
    }

    getFixupPrototypeFunction() { return ShareTargetForReservation.fixupPrototype; }

    static newInstance(model: Partial<ShareTargetForReservation>): ShareTargetForReservation {
        let obj = Object.assign(new ShareTargetForReservation(), model);
        ShareTargetForReservation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ShareTargetForReservation>): ShareTargetForReservation {
        if (!model) return null;
        return ShareTargetForReservation.newInstance(<ShareTargetForReservation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ShareTargetForReservation) {
        if (!obj) return;

        models.ShareTargetForReservation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ShareTargetForReservation): boolean {
        if (models.ShareTarget.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ShareTargetForReservation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
